import { getItem,setItem } from './localStorage.js';
export const filters = {
    namespaced: true,
state:{
jobFilters:JSON.parse(getItem('jobFilters') || '[]'),
historyFilters:JSON.parse(getItem('historyFilters') || '[]'),
historyDefaultFilter:JSON.parse(getItem('historyDefaultFilter') || '[]'),
appFilters:JSON.parse(getItem('appFilters') || '[]'),
candidateFilters:JSON.parse(getItem('candidateFilters') || '[]'),
userFilter:JSON.parse(getItem('userFilter') || '[]'),
},



mutations:{
      updateJobFilter(state,filterData){
        state.jobFilters=filterData
        setItem('jobFilters', JSON.stringify(filterData));
    },
    updateHistoryFilter(state,filterData){
        state.historyFilters=filterData
        setItem('historyFilters', JSON.stringify(filterData));
    },
    updateHistoryDefaultFilter(state,filterData){
        state.historyDefaultFilter=filterData
        setItem('historyDefaultFilter', JSON.stringify(filterData));
    },
    updateApplicationFilter(state,filterData){
        state.appFilters=filterData
        setItem('appFilters', JSON.stringify(filterData));
    },
    updateCandidateFilter(state,filterData){
        state.candidateFilters=filterData
        setItem('candidateFilters', JSON.stringify(filterData));
    },
    updateUserFilter(state,filterData){
        state.userFilter=filterData
        setItem('userFilter', JSON.stringify(filterData));
    }

},




   

 
  };